import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import { Mail, Phone, Linkedin, Instagram, MapPin } from "lucide-react";

const Footer = () => {
  const { lang } = useLang();
  const t = translations[lang].footer;

  return (
    <footer data-testid="footer-section" className="bg-navy-dark">
      {/* Google Maps */}
      <div data-testid="footer-map" className="w-full h-[200px] md:h-[250px] grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500">
        <iframe
          title="OKontainers Location - Malaga, Spain"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102279.45684498364!2d-4.530117!3d36.7213028!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd7259c58eb3c289%3A0x40463fd8ca505e0!2sM%C3%A1laga%2C%20Spain!5e0!3m2!1ses!2ses!4v1705000000000!5m2!1ses!2ses"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <div className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
            <div>
              <img src="/logo.png" alt="OKontainers" className="h-10 w-auto object-contain brightness-0 invert mb-5" />
              <p className="text-slate-400 text-sm leading-relaxed font-body max-w-xs">{t.tagline}</p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-5 font-heading">{t.contact}</h4>
              <div className="space-y-3">
                <a data-testid="footer-email" href="mailto:info@okontainers.com" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors text-sm font-body">
                  <Mail size={16} />info@okontainers.com
                </a>
                <a data-testid="footer-phone" href="https://wa.me/34672808030" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors text-sm font-body">
                  <Phone size={16} />+34 672 808 030
                </a>
                <div data-testid="footer-location" className="flex items-center gap-3 text-slate-400 text-sm font-body">
                  <MapPin size={16} className="shrink-0" />{t.location}
                </div>
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-5 font-heading">{t.followUs}</h4>
              <div className="flex gap-3">
                <a data-testid="footer-linkedin" href="https://www.linkedin.com/company/okontainers-logistics/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                  <Linkedin size={18} />
                </a>
                <a data-testid="footer-instagram" href="https://www.instagram.com/okontainers_official" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                  <Instagram size={18} />
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-5 font-heading">{t.legal}</h4>
              <div className="space-y-3">
                <a data-testid="footer-knowledge" href="/aprende" className="block text-slate-400 hover:text-white transition-colors text-sm font-body">{lang === "es" ? "Centro de Conocimiento" : "Knowledge Center"}</a>
                <a data-testid="footer-academies" href="/academias" className="block text-slate-400 hover:text-white transition-colors text-sm font-body">{lang === "es" ? "Para Academias" : "For Academies"}</a>
                <a data-testid="footer-cookie-policy" href="/cookies" className="block text-slate-400 hover:text-white transition-colors text-sm font-body">{t.cookiePolicy}</a>
                <a data-testid="footer-privacy-policy" href="/privacy" className="block text-slate-400 hover:text-white transition-colors text-sm font-body">{t.privacyPolicy}</a>
              </div>
            </div>
          </div>
          <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-xs font-body">Copyright &copy; {new Date().getFullYear()} OKontainers | Powered by OKontainers</p>
            <p className="text-slate-600 text-xs font-body">{t.rights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
